module.exports = __webpack_public_path__ + "static/media/README.3d69dab8.md";